/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useMemo,
  useContext,
  useReducer,
  useRef,
  useState,
} from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import {
  IoArrowBack,
  IoPlay,
  IoTrashBinOutline,
  IoStop,
  IoStopCircleOutline,
} from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { ControlBar, Player } from "video-react";
import ReactPlayer from "react-player/lazy";
import { useDrag } from "react-use-gesture";
import useMedia from "../../hooks/useMedia";
import { trimTime } from "../../functions/record-functions";

// -----
import LoaderSvg from "../../assets/loader.svg";
import { RecordRTCPromisesHandler } from "recordrtc";
import { recordDuration } from "../../functions/record-functions";
import { CircularProgressbar } from "react-circular-progressbar";
import config from "../../config/config";
// ----

export const Edit = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const videos = useSelector((state) => state.record.recordedVideoData);
  const [currentVideo, setCurrentVideo] = useState();
  const [currentIndexVid, setCurrentIndexVid] = useState(1);
  const [state, setState] = useState();
  const [play, setPlay] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentVideo(videos[0]);
    setState(videos);
  }, [videos]);

  useMemo(() => {
    dispatch({ type: "record/editVideo", payload: currentVideo });
  }, [currentVideo]);

  const deleteVideo = () => {
    dispatch({ type: "record/deleteVideo", payload: currentVideo.id });
  };

  const allVideos = useMemo(() => {
    return state?.map((item, index) => (
      <span key={index} className="relative">
        <p className="absolute lg:flex text-xs top-0 -left-2 text-[#515A6B]">
          {index + 1}.
        </p>
        <label
          htmlFor={index}
          className="w-[2.5rem] lg:w-[3rem] rounded-full aspect-square hover:cursor-pointer"
        >
          <input
            id={index}
            type="radio"
            name="editVideo"
            onChange={() => {
              setCurrentIndexVid(index + 1);
              setCurrentVideo(item);
              dispatch({ type: "record/editVideo", payload: item });
            }}
          />
          <ReactPlayer
            url={window.URL.createObjectURL(item.file)}
            className="option rounded-full overflow-hidden border-2 border-white"
            width={48}
            height={48}
          />
        </label>
      </span>
    ));
  }, [state]);

  const react_player = useMemo(() => {
    if (currentVideo) {
      return (
        <ReactPlayer
          url={window.URL.createObjectURL(currentVideo.file)}
          className="rounded-full overflow-hidden m-auto"
          width={92}
          height={92}
          playing={play}
          onEnded={() => setPlay(false)}
        />
      );
    }
  }, [currentVideo, play]);

  const currenVidBlob = useMemo(() => {
    if (currentVideo) {
      return window.URL.createObjectURL(currentVideo.file);
    }
  }, [currentVideo]);

  return (
    <div
      id="main-edit"
      className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden"
    >
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack color="#2C3037" className="m-auto w-full text-xs" />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053]">
          Edit Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-4 flex flex-col space-y-3 items-center pt-4 pb-4">
        <span className="w-full flex flex-col items-center space-y-2">
          <span className="w-[6rem] relative bg-[#ECF5FC66] rounded-full flex aspect-square flex-col shadow-md">
            <p className="absolute lg:flex text-xs top-0 -left-2 text-[#515A6B]">
              {currentIndexVid}.
            </p>
            {currentVideo ? (
              <>
                <ReactPlayer
                  url={currenVidBlob}
                  className="rounded-full overflow-hidden m-auto"
                  width={92}
                  height={92}
                  playing={play}
                  onEnded={() => setPlay(false)}
                />

                <button
                  onClick={() => setPlay(!play)}
                  className="absolute bg-gradient-to-tr from-[#F1F9FF] to-[#DCE8F6] rounded-full p-[2px] bottom-2 right-[40%]"
                >
                  {play ? (
                    <IoStop className="text-xs text-gray-400" />
                  ) : (
                    <IoPlay className="text-xs text-gray-400" />
                  )}
                </button>
              </>
            ) : null}
          </span>
          <div className="w-full grid grid-cols-2 text-sm space-y-4">
            <div className=" col-span-2 w-full h-full flex flex-row space-x-3 justify-center">
              {allVideos}
            </div>
            <button
              onClick={props.trim}
              className="bg-[#FFFFFFB2] py-2 rounded-lg w-[75%] justify-self-end text-[#7B94B5] flex flex-row items-center justify-center space-x-1 shadow-sm"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 21 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4974 3.33774L16.5858 7.42608L6.23697 17.7749L2.15091 13.6866L12.4974 3.33774ZM19.6881 2.35173L17.8648 0.52847C17.1602 -0.176157 16.016 -0.176157 15.309 0.52847L13.5625 2.27497L17.6509 6.36335L19.6881 4.32615C20.2346 3.7796 20.2346 2.89824 19.6881 2.35173ZM0.011377 19.433C-0.0630262 19.7679 0.239299 20.0679 0.574189 19.9865L5.13 18.8819L1.04394 14.7936L0.011377 19.433Z"
                  fill={bg}
                />
              </svg>
              <p style={{ color: bg }} className="text-xs">
                Edit Qcast
              </p>
            </button>
            <button
              onClick={deleteVideo}
              disabled={videos.length <= 1}
              className="bg-[#FFFFFFB2] py-2 w-[75%] rounded-lg text-[#7B94B5] flex flex-row items-center justify-center space-x-1 shadow-sm"
            >
              <IoTrashBinOutline color={bg} />
              <p style={{ color: bg }} className="text-xs">
                Delete Video
              </p>
            </button>
          </div>
        </span>
        <button
          style={{ backgroundColor: bg, color: font }}
          className="w-[50%] mt-4 px-12 text-xs py-2 flex-grow rounded-full p-1 shadow-md"
          onClick={props.save}
        >
          Save
        </button>
      </div>
    </div>
  );
};

const initFr = [];
const reduceFr = (state, action) => {
  switch (action.type) {
    case "reset":
      return [];
    case "setFrame":
      return [...state, action.payload];
    default:
      return state;
  }
};

export const Trim = (props) => {
  const md = useMedia("(min-width: 768px)");
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;

  const currentData = useSelector((store) => store.record.editVideo);
  const { duration } = currentData;
  const rdDispatch = useDispatch();

  const originalVideo = useSelector(
    (state) =>
      state.record.recordedVideoData.filter((dt) => dt.id === currentData.id)[0]
  );

  const [state, setState] = useState(false);
  const imgRef = useRef();
  const [frameReducer, dispatch] = useReducer(reduceFr, initFr);
  const [durr, setDurr] = useState();
  const [play, setPlay] = useState(false);

  const [startPos, setStartPos] = useState({ a: 0 });
  const [endPos, setEndPos] = useState({ a: 0 });
  const [startTime, setStartTime] = useState(startPos.a);
  const [endTime, setEndTime] = useState(endPos.a);
  const [isLoading, setIsLoading] = useState(true);

  const [showTrimText, setShowTrimText] = useState(false);

  const [vidInfo, setVidInfo] = useState({});

  const vidRef = useRef();

  useEffect(() => {
    getFrames(currentData)
      .then(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (vidRef.current) {
      vidRef.current.subscribeToStateChange(handleVidStateChange);
    }
  }, [vidRef.current]);

  useEffect(() => {
    console.log(Math.floor(vidInfo.currentTime), endTime);
    if (Math.floor(vidInfo.currentTime) === Math.floor(endTime)) {
      vidRef.current.pause();
      setPlay(false);
      vidRef.current.seek(startTime);
    }
  }, [vidInfo]);

  const handleVidStateChange = (state) => {
    // copy player state to this component's state
    setVidInfo(state);
  };

  const bindstartPos = useDrag(
    (state) => {
      if (state.active) {
        props.setIsTrimming(true);
        setShowTrimText(true);
      } else {
        props.setIsTrimming(false);
        setShowTrimText(false);
      }
      setStartPos({
        a: state.offset[0],
      });

      md
        ? setStartTime(
            parseFloat((startPos.a / (284 / Math.floor(durr))).toFixed(2))
          )
        : setStartTime(
            parseFloat((startPos.a / (258 / Math.floor(durr))).toFixed(2))
          );

      vidRef.current.seek(startTime);
    },
    {
      bounds: {
        left: 0,
        right: md ? 284 + endPos.a : 258 + endPos.a,
      },
    }
  );

  const bindEndPos = useDrag(
    (state) => {
      if (state.active) {
        props.setIsTrimming(true);
        setShowTrimText(true);
      } else {
        props.setIsTrimming(false);
        setShowTrimText(false);
      }
      setEndPos({
        a: state.offset[0],
      });

      md
        ? setEndTime(
            parseFloat((durr + endPos.a / (284 / Math.floor(durr))).toFixed(2))
          )
        : setEndTime(
            parseFloat((durr + endPos.a / (258 / Math.floor(durr))).toFixed(2))
          );
    },
    {
      bounds: {
        right: 0,
        left: md ? -284 + startPos.a : -258 + startPos.a,
      },
    }
  );

  useEffect(() => {
    duration.then((dur) => {
      setDurr(Math.floor(dur));
      setEndTime(Math.floor(dur));
    });
    (frameReducer.length === Math.floor(durr) || frameReducer.length === 9) &&
      setState(true);
  }, [frameReducer]);

  async function blobToDataURL(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.onabort = () => reject(new Error("Read aborted"));
      reader.readAsDataURL(blob);
    });
  }

  const getFrames = async (currentData) => {
    dispatch({ type: "reset" });
    const { file, duration } = currentData;

    const payload = new FormData();
    payload.append("video", file);

    const length = await duration;

    const res = await fetch(`${config.editBaseUrl}/frames?duration=${length}`, {
      method: "POST",
      body: payload,
    });

    if (!res.ok) {
      throw new Error("Creating thumbnail failed");
    }

    const frameBlob = await res.json();

    frameBlob.forEach(async (item) => {
      let arr = new Uint8Array(item.data);
      let blob = new Blob([arr]);
      const frame = await blobToDataURL(blob);
      dispatch({ type: "setFrame", payload: frame });
    });
  };

  useMemo(() => {
    setStartPos({ a: 0 });
    setEndPos({ a: 0 });
    if (typeof document !== "undefined") {
      const check = document.getElementById("frameSpan");

      if (check?.childElementCount <= 0) {
        frameReducer.forEach((frame) => {
          let image = document.createElement("img");
          image.src = frame;
          image.setAttribute(
            "class",
            "object-fill select-none pointer-events-none h-full"
          );
          imgRef.current.appendChild(image);
        });
      }
    }
  }, [state]);

  const currenVidBlob = useMemo(() => {
    return window.URL.createObjectURL(currentData.file);
  }, [currentData]);

  const handleTrim = async () => {
    const payload = new FormData();
    payload.append("video", currentData.file);

    const strtTime = trimTime(startTime);
    const edTime = trimTime(endTime);

    if (durr > 9) {
      const res = await fetch(
        `${config.editBaseUrl}/trim?startTime=${strtTime}&endTime=${edTime}`,
        {
          method: "POST",
          body: payload,
        }
      );
      const data = await res.blob();

      rdDispatch({ type: "record/saveEditedVideo", payload: data });

      setStartPos({ a: 0 });
      setEndPos({ a: 0 });
      setStartTime(0);
      await getFrames(currentData);
      document.getElementById("frameSpan").innerHTML = "";
      setState(false);
    } else {
      alert("cannot trim video less that 10secs");
    }
  };

  const handleUndo = async (e) => {
    e.preventDefault();
    rdDispatch({ type: "record/editVideo", payload: originalVideo });

    await getFrames(originalVideo);
    document.getElementById("frameSpan").innerHTML = "";
    setStartPos({ a: 0 });
    setEndPos({ a: 0 });
    setStartTime(0);
    // setEndTime()
    setState(false);
  };

  const handleSave = (callback) => {
    rdDispatch({ type: "record/save", payload: currentData });
    callback();
  };

  const SSTOMIN = (sec) => {
    var regx = /^[0-9.]+$/;
    if (!regx.test(sec)) {
      return "--:--";
    }

    var sec_num = parseInt(sec, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ":" + seconds;
  };

  if (isLoading) {
    return (
      <div
        id="main-edit"
        className="main-trim w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden"
      >
        <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 py-2 shadow-sm">
          <button
            className="justify-self-start mr-2 w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
            onClick={props.back}
          >
            <IoArrowBack
              color="#2C3037"
              className="m-auto w-full text-xs lg:text-sm"
            />
          </button>
          <p className="font-medium w-fit justify-self-center text-[#1E3053]">
            Trim Qcast
          </p>
          <span></span>
        </nav>
        {/* BODY */}
        <div className="w-full h-72 px-2 md:px-8 lg:px-[4rem] flex flex-col gap-3 items-center justify-center pt-4 pb-4">
          <div className="w-24">
            {" "}
            <img src={LoaderSvg} alt="Loader" />{" "}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      id="main-edit"
      className="main-trim w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden"
    >
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack
            color="#2C3037"
            className="m-auto w-full text-xs lg:text-sm"
          />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053]">
          Trim Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 lg:px-[4rem] flex flex-col space-y-3 items-center pt-4 pb-4">
        <span className="w-full flex flex-col items-center space-y-2">
          <span
            id="respond-video-record"
            className="w-[6rem] h-[6rem] relative bg-[#ECF5FC66] rounded-full flex aspect-square flex-col shadow-md"
          >
            <Player
              ref={vidRef}
              src={currenVidBlob}
              className="rounded-full overflow-hidden m-auto"
              fluid={false}
              width={85}
              aspectRatio={"1:1"}
            >
              <ControlBar disableCompletely />
            </Player>
            <button
              // onClick={startPlay}
              onClick={() => {
                if (play) {
                  vidRef.current.pause();
                  setPlay(false);
                } else {
                  vidRef.current.play();
                  setPlay(true);
                }
              }}
              className="absolute bg-gradient-to-tr from-[#F1F9FF] to-[#DCE8F6] rounded-full p-[2px] bottom-2 right-[40%]"
            >
              {play ? (
                <IoStop className="text-xs text-gray-400" />
              ) : (
                <IoPlay className="text-xs text-gray-400" />
              )}
            </button>
          </span>
          <div className="w-full grid grid-cols-2 text-sm space-y-2">
            <p
              className={`col-span-2 text-center ${
                !showTrimText ? "invisible" : ""
              }`}
            >
              {SSTOMIN(startTime.toFixed(2))} - {SSTOMIN(endTime.toFixed(2))}
            </p>

            <span className="relative col-span-2 w-full mx-auto border-t border-b border-gradient-to-tr from-[#F1F9FF] to-[#DCE8F6]">
              <span
                className="absolute left-0 top-0 bottom-0 backdrop-filter backdrop-blur-sm"
                style={{ width: startPos.a }}
              ></span>
              <button
                style={{ position: "absolute", left: startPos.a }}
                {...bindstartPos()}
                className="z-10 flex flex-col h-full w-3 bg-gradient-to-tr from-[#F1F9FF] to-[#DCE8F6]"
              >
                <hr color="#97AAC3" className="w-[2px] h-[60%] m-auto" />
              </button>
              {/* FRAMES */}
              <div
                id="frameSpan"
                ref={imgRef}
                className="grid grid-flow-col place-items-center justify-center w-full h-[3rem] lg:h-[3.5rem] overflow-hidden"
              ></div>
              <button
                style={{ position: "absolute", right: -endPos.a }}
                {...bindEndPos()}
                className="z-10 h-full w-3 flex flex-col top-0 right-0 bg-gradient-to-tr from-[#F1F9FF] to-[#DCE8F6]"
              >
                <hr color="#97AAC3" className="w-[2px] h-[60%] m-auto" />
              </button>
              <span
                className="absolute right-0 top-0 bottom-0 backdrop-filter backdrop-blur-sm"
                style={{ width: -endPos.a }}
              ></span>
            </span>
            <p className="col-span-2 text-center">
              {SSTOMIN((endTime - startTime).toFixed(2))}
            </p>
            <button
              className="bg-[#FFFFFFB2] text-[#7B94B5] rounded-md shadow-sm py-1 flex flex-row items-center justify-center space-x-1"
              onClick={handleUndo}
            >
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.24013 3.53337H4.01762L5.54666 2.01609C5.76814 1.79461 5.89257 1.49422 5.89257 1.181C5.89257 0.867779 5.76814 0.567387 5.54666 0.345907C5.32518 0.124426 5.02479 0 4.71157 0C4.39835 0 4.09796 0.124426 3.87648 0.345907L0.347914 3.87447C0.237672 3.98381 0.150171 4.1139 0.0904572 4.25723C0.0307438 4.40056 0 4.55429 0 4.70956C0 4.86483 0.0307438 5.01857 0.0904572 5.1619C0.150171 5.30523 0.237672 5.43531 0.347914 5.54465L3.87648 9.07322C4.09796 9.2947 4.39835 9.41912 4.71157 9.41912C5.02479 9.41912 5.32518 9.2947 5.54666 9.07322C5.76814 8.85174 5.89257 8.55134 5.89257 8.23812C5.89257 7.9249 5.76814 7.62451 5.54666 7.40303L4.01762 5.88575H8.24013C9.40327 5.88575 10.5403 6.23066 11.5074 6.87687C12.4745 7.52307 13.2283 8.44155 13.6734 9.51615C14.1185 10.5907 14.235 11.7732 14.0081 12.914C13.7812 14.0548 13.221 15.1027 12.3986 15.9251C11.5761 16.7476 10.5282 17.3077 9.38745 17.5346C8.24666 17.7615 7.0642 17.6451 5.98959 17.2C4.91499 16.7548 3.99652 16.0011 3.35031 15.034C2.70411 14.0668 2.35919 12.9298 2.35919 11.7667C2.35919 11.4547 2.23528 11.1556 2.0147 10.935C1.79412 10.7144 1.49495 10.5905 1.18301 10.5905C0.871063 10.5905 0.571895 10.7144 0.351317 10.935C0.13074 11.1556 0.00681993 11.4547 0.00681993 11.7667C0.00681993 13.3951 0.489695 14.9869 1.39438 16.3409C2.29907 17.6948 3.58494 18.7501 5.08938 19.3733C6.59382 19.9964 8.24926 20.1595 9.84637 19.8418C11.4435 19.5241 12.9105 18.74 14.062 17.5885C15.2134 16.4371 15.9976 14.97 16.3152 13.3729C16.6329 11.7758 16.4699 10.1204 15.8467 8.61593C15.2236 7.11149 14.1683 5.82563 12.8143 4.92094C11.4604 4.01625 9.86853 3.53337 8.24013 3.53337Z"
                  fill={bg}
                />
              </svg>
              <p style={{ color: bg }} className="lg:text-sm text-xs py-1">
                Undo Trim
              </p>
            </button>
            <button
              onClick={handleTrim}
              className="bg-[#FFFFFFB2] text-[#7B94B5] rounded-md shadow-sm py-1 flex flex-row items-center justify-center space-x-1"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5856 4.03641C15.5856 4.03641 12.4229 6.02343 9.14711 8.08218L7.66103 7.16581C7.46858 7.0449 7.33166 6.85245 7.28557 6.62972C7.2377 6.40853 7.28403 6.17635 7.41131 5.98544C8.52013 4.08906 7.88376 1.6533 5.98887 0.54293C5.14583 0.0513831 4.20067 -0.0949824 3.30975 0.0577467C2.19152 0.249951 1.16239 0.916599 0.546605 1.96989C-0.562221 3.86782 0.0741495 6.30358 1.97053 7.41086C1.99266 7.42513 3.80174 8.56115 6.09422 9.99935C3.80661 11.4375 1.99296 12.5733 1.96899 12.5894C0.0726084 13.6951 -0.563762 16.1324 0.545064 18.0304C1.16055 19.0834 2.18993 19.7501 3.30845 19.9425C4.19937 20.0952 5.14453 19.9473 5.98758 19.4555C7.88242 18.3467 8.52033 15.9094 7.40972 14.013C7.28398 13.8236 7.2379 13.593 7.28577 13.3687C7.33365 13.1475 7.47032 12.9536 7.66277 12.8342L9.14706 11.9178C9.57825 12.1915 11.581 13.3703 12.0028 13.636H18.2313L12.2495 9.9993L21.9223 4.02045C20.0099 2.94364 17.6044 2.85604 15.5856 4.03641ZM5.18098 18.0829C4.68943 18.3693 4.13579 18.4711 3.57578 18.3741C2.8788 18.2547 2.27455 17.8362 1.91639 17.2253C1.25303 16.091 1.63336 14.6274 2.77067 13.9607C2.83585 13.9241 2.90913 13.9162 2.97734 13.8843C3.41644 13.6792 3.89039 13.5853 4.37736 13.6664C4.77673 13.7364 5.13946 13.9113 5.44949 14.1598C5.67859 14.341 5.88556 14.5591 6.03341 14.8168C6.69703 15.9541 6.31854 17.4193 5.18098 18.0829ZM6.03371 5.18187C5.88581 5.44125 5.67889 5.65761 5.44979 5.84067C5.13951 6.08582 4.77678 6.26221 4.37766 6.33067C3.89068 6.4134 3.41674 6.32128 2.97918 6.11431C2.91072 6.08403 2.83764 6.07612 2.77251 6.03948C1.63341 5.37284 1.25492 3.90918 1.91823 2.77336C2.27614 2.16399 2.88069 1.74547 3.57762 1.62456C4.13763 1.52756 4.69127 1.63093 5.18282 1.91575C6.31854 2.58091 6.69703 4.04456 6.03371 5.18187Z"
                  fill={bg}
                />
              </svg>
              <p style={{ color: bg }} className="lg:text-sm text-xs">
                Trim Video
              </p>
            </button>
          </div>
        </span>
        <button
          style={{ backgroundColor: bg, color: font }}
          onClick={() => handleSave(props.save)}
          className="w-[60%] mt-4 shadow-md px-12 lg:text-sm text-xs py-2 flex-grow rounded-full p-1"
        >
          Save
        </button>
      </div>
    </div>
  );
};

const initTh = [];
const reducerTh = (state, action) => {
  if (action.type === "reset") {
    return [];
  }
  return [...state, action];
};

export const Thumbnail = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;

  const videoFile = useSelector((state) => state.record.recordedVideoData);
  const { duration } = videoFile[0];
  const [thumbnailReducer, dispatch] = useReducer(reducerTh, initTh);
  const [state, setState] = useState(false);
  const [selectedthumb, setSelectedThumb] = useState("");
  const rnDispatch = useDispatch();
  const imgRef = useRef();
  const [durr, setDurr] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    duration.then((dur) => setDurr(Math.floor(dur)));
    (thumbnailReducer.length === Math.floor(durr) ||
      thumbnailReducer.length === 6) &&
      setState(true);
  }, [thumbnailReducer]);

  async function blobToDataURL(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.onabort = () => reject(new Error("Read aborted"));
      reader.readAsDataURL(blob);
    });
  }

  const getFrames = async (recorded) => {
    const { file, duration } = recorded;

    const payload = new FormData();
    payload.append("video", file);

    const length = await duration;

    const res = await fetch(`${config.editBaseUrl}/frames?duration=${length}`, {
      method: "POST",
      body: payload,
    });

    if (!res.ok) {
      throw new Error("Creating thumbnail failed");
    }

    const frameBlob = await res.json();

    frameBlob.forEach(async (item) => {
      let arr = new Uint8Array(item.data);
      let blob = new Blob([arr]);
      const frame = await blobToDataURL(blob);
      dispatch(frame);
    });
  };

  useEffect(() => {
    getFrames(videoFile[0])
      .then(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const allThumbnails = useMemo(() => {
    return thumbnailReducer?.map((frame, index) => (
      <span key={index} className="relative">
        <label
          htmlFor={index}
          className="w-[2.5rem] rounded-full aspect-square hover:cursor-pointer"
        >
          <input
            id={index}
            type="radio"
            name="selectThumbnail"
            onChange={() => {
              setSelectedThumb({
                img: frame,
                id: index,
              });
            }}
          />

          <img
            src={frame}
            className="thumb-option w-[4rem] h-[4rem] lg:w-[7rem] lg:h-[7rem] border-8 border-[#FFFFFF80] rounded-full m-auto object-cover"
            alt={`Thumbnail - ${index}`}
          />
        </label>
      </span>
    ));
  }, [state]);

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  const handleRandomize = (e) => {
    e.preventDefault();
    dispatch({ type: "reset" });
    shuffle(thumbnailReducer).map((frame) => dispatch(frame));
    setState(!state);
  };

  const handleUserSelect = (e) => {
    e.preventDefault();
    if (selectedthumb) {
      rnDispatch({ type: "record/addThumbnail", payload: selectedthumb.img });
      props.back();
    } else {
      alert("Nothing selected");
    }
  };

  if (isLoading) {
    return (
      <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
        <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2">
          <button
            className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
            onClick={props.back}
          >
            <IoArrowBack color="#2C3037" className="m-auto w-full text-xs" />
          </button>
          <p className="font-medium w-fit justify-self-center text-[#1E3053] whitespace-nowrap">
            Add Thumbnail
          </p>
          <span></span>
        </nav>
        {/* BODY */}
        <div className="w-full h-72 px-2 md:px-4 flex flex-col gap-3 items-center justify-center pt-4 pb-6">
          <div className="w-24">
            {" "}
            <img src={LoaderSvg} alt="Loader" />{" "}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack color="#2C3037" className="m-auto w-full text-xs" />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053] whitespace-nowrap">
          Add Thumbnail
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-4 flex flex-col space-y-3 items-center pt-4 pb-6">
        <div className="w-full flex gap-y-4">
          {/* THUMBNAIL */}
          <div
            id="frameSpan"
            ref={imgRef}
            className="w-[70%] mx-auto grid grid-cols-3 place-items-center space-x-4"
          >
            {allThumbnails}
          </div>
        </div>
        <div className="w-[70%] grid grid-cols-2 text-sm space-x-2 place-items-center">
          <button
            style={{ color: bg }}
            className="px-12 bg-[#FFFFFFB2] text-xs flex-grow rounded-full col-span-2 w-full py-2 shadow-md"
            onClick={handleRandomize}
          >
            Randomize my thumbnail
          </button>
          <button
            style={{ backgroundColor: bg, color: font }}
            onClick={props.back}
            className="text-xs rounded-full py-2 w-full justify-self-end px-6 shadow-md"
          >
            Cancel
          </button>
          <button
            style={{ backgroundColor: bg, color: font }}
            className="text-xs py-2 w-full px-2 rounded-full justify-self-start shadow-md"
            onClick={handleUserSelect}
          >
            Use selected
          </button>
        </div>
      </div>
    </div>
  );
};

const init = {
  one: "",
  two: "",
  three: "",
  four: "",
  five: "",
  six: "",
  seven: "",
  eight: "",
  nine: "",
  ten: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case 1:
      return { ...state, one: action.payload };
    case 2:
      return { ...state, two: action.payload };
    case 3:
      return { ...state, three: action.payload };
    case 4:
      return { ...state, four: action.payload };
    case 5:
      return { ...state, five: action.payload };
    case 6:
      return { ...state, six: action.payload };
    case 7:
      return { ...state, seven: action.payload };
    case 8:
      return { ...state, eight: action.payload };
    case 9:
      return { ...state, nine: action.payload };
    case 10:
      return { ...state, ten: action.payload };
    default:
      return {};
  }
};

export const Transcript = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const videoWithData = useSelector((state) => state.record.recordedVideoData);
  const [input, dispatch] = useReducer(reducer, init);
  const rdDispatch = useDispatch();

  const save = () => {
    const transcript = [
      input.one,
      input.two,
      input.three,
      input.four,
      input.five,
      input.six,
      input.seven,
      input.eight,
      input.nine,
      input.ten,
    ].filter((item) => item !== "");

    rdDispatch({ type: "record/addTranscript", payload: transcript });
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack color="#2C3037" className="m-auto w-full text-xs" />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053] whitespace-nowrap">
          Edit Transcript
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-4 flex flex-col gap-3 items-center py-4">
        {videoWithData.map((item, index) => (
          <div key={item.id} className="w-full text-xs flex flex-row gap-1">
            <p>{index + 1}.</p>
            <textarea
              onChange={(e) =>
                dispatch({ type: index + 1, payload: e.target.value })
              }
              className="scroll flex-grow resize-none rounded-lg p-1 bg-[#FFFFFF80] shadow-sm text-[#515A6B]"
            />
          </div>
        ))}
        <button
          onClick={save}
          style={{ backgroundColor: bg, color: font }}
          className="w-fit mt-4 px-12 flex-grow rounded-full p-1 text-xs py-2 shadow-md"
        >
          Save Transcript
        </button>
      </div>
    </div>
  );
};

export const IntroOrOutro = (props) => {
  const [record, setRecord] = useState(false);
  const [recorder, setRecorder] = useState();
  const [blob, setBlob] = useState(null);
  const [stream, setStream] = useState();
  const [startRecording, setStartRecording] = useState(false);
  const [initStream, setinitStream] = useState();
  const videoRef = useRef(null);
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(0);
  const [interval, setIntervals] = useState();

  const [countStartTime, setCountStartTime] = useState(5);
  const [countInterval, setCountInterval] = useState();

  useEffect(() => {
    (async function () {
      await liveRecord();
    })();

    return () => {
      stream.getTracks().forEach(function (track) {
        if (track.readyState == "live") {
          track.stop();
        }
      });
    };
  }, []);

  useEffect(() => {
    (async function () {
      if (countStartTime < 1) {
        clearInterval(countInterval);
        await startTemp();
      }
    })();
  }, [countStartTime]);

  const liveRecord = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: {
        width: 1280,
        height: 720,
      },
    });
    setinitStream(stream);
    const video = videoRef.current;
    video.srcObject = stream;
    video.play();
  };

  const start = async () => {
    setCountInterval(
      setInterval(() => setCountStartTime((timer) => timer - 1), 1000)
    );
  };

  const startTemp = async () => {
    setStartRecording(true);
    setCountStartTime(5);
    setCountInterval(null);
    await liveRecord();
    if (typeof window !== "undefined") {
      const streaming = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: {
          width: 250,
          height: 250,
        },
      });
      const record = new RecordRTCPromisesHandler(streaming, {
        type: "video",
        mimeType: "video/webm;codecs=vp9",
      });
      await record.startRecording();
      setRecorder(record);
      setStream(streaming);
      setIntervals(setInterval(() => setTimer((timer) => timer + 1), 1000));
      setRecord(true);
    }
  };

  const stop = async () => {
    initStream.getTracks().forEach((track) => track.stop());
    clearInterval(interval);
    stream.stop();
    await recorder.stopRecording();
    const recordedBlob = await recorder.getBlob();
    setBlob(recordedBlob);
    if (props.type === "intro") {
      dispatch({ type: "record/addIntro", payload: recordedBlob });
    } else {
      dispatch({ type: "record/addOutro", payload: recordedBlob });
    }

    setStream(null);
    setRecorder(null);
    setRecord(true);
  };

  useEffect(() => {
    (async function () {
      if (timer === 60) {
        await stop();
      }
    })();
  }, [timer]);

  const duration = recordDuration(timer);

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col overflow-hidden">
      <nav className="w-full flex flex-row justify-center space-x-2 px-2 items-center py-2 ">
        <button
          className="w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] border border-[#D1E6FC] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack className="m-auto w-full text-xs fill-[#2C3037]" />
        </button>
        <p className="bg-[#FFFFFF80] text-[#515A6B] mr-5 backdrop-blur-[50px] px-6 rounded-full w-fit justify-self-end text-xs py-2 font-semibold whitespace-nowrap">
          {props.type === "intro" ? "Add Intro" : "Add Outro"}
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full md:px-8 lg:px-[4rem] flex flex-col space-y-1 items-center pb-6 ">
        <span className="relative w-[270px] h-[270px] rounded-full overflow-hidden flex flex-col">
          <CircularProgressbar value={timer} maxValue={60} strokeWidth={4} />
          <div
            className={`relative ${
              countInterval ? "record-wrapper" : ""
            } w-[250px] rounded-full aspect-square m-auto mt-[.6rem] flex flex-col bg-[#FFFFFFCC]`}
          >
            {blob ? (
              <Player
                src={window.URL.createObjectURL(blob)}
                className="rounded-full overflow-hidden m-auto"
                fluid={false}
                width={250}
                aspectRatio={"1:1"}
              />
            ) : (
              <>
                {countInterval && (
                  <p
                    className="text-white text-4xl absolute top-[50%] left-[50%] transform -translate-y-1/2 -translate-x-1/2"
                    style={{ zIndex: "123412312312" }}
                  >
                    {" "}
                    {countStartTime}{" "}
                  </p>
                )}
                <video
                  ref={videoRef}
                  muted
                  className="h-[250px] aspect-square rounded-full m-auto object-cover"
                />
              </>
            )}
          </div>
        </span>
        <div className="w-fit bg-[#FFFFFFCC] shadow-md grid grid-cols-3 place-items-center rounded-3xl py-2 px-2 space-x-4">
          <p className="text-[#515A6B] text-xs lg:text-sm">
            {duration ? duration : "00:00"}
          </p>
          <button
            onClick={async () => {
              if (!record) {
                await start();
                return;
              }
              await stop();
              props.back();
            }}
            className="bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full p-1"
          >
            {record ? (
              <IoStop className="text-[#F88686] h-[1.5em] w-[1.5em]" />
            ) : (
              <IoStopCircleOutline className="text-[#F88686] h-[1.5em] w-[1.5em]" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
